export const TypeformIsShownKey = "scmp-search-result-typeform-is-shown";

// cspell:disable-next-line
export const TypeformId = "nmaHYBYA";
